import script from "./ModalModificarBasesTorneo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalModificarBasesTorneo.vue?vue&type=script&setup=true&lang=ts"

import "./ModalModificarBasesTorneo.vue?vue&type=style&index=0&id=33cc6008&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33cc6008"]])

export default __exports__